import $ from 'jquery';
import 'malihu-custom-scrollbar-plugin';
import 'jquery-mousewheel';
$('#js-custom-scoll').mCustomScrollbar();



// WEBPACK FOOTER //
// ./resources/assets/js/autoload/_mCustomScrollbar.js